module.exports = __webpack_public_path__ + "static/media/HiddenIcon.98675538.svg";